function Nauru({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1737)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#0052B4"/>
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M16 0C7.63222 0 0.7661 6.42381 0.0609131 14.6087H31.9391C31.2338 6.42381 24.3677 0 16 0Z" fill="#0052B4"/>
  <path d="M16 32.0003C24.3677 32.0003 31.2338 25.5765 31.9391 17.3916H0.0609131C0.7661 25.5765 7.63222 32.0003 16 32.0003Z" fill="#0052B4"/>
  <path d="M13.2175 21.5655L11.4246 22.4089L12.3793 24.1452L10.4325 23.7727L10.1858 25.7394L8.82971 24.293L7.47371 25.7394L7.22702 23.7727L5.28014 24.1451L6.23489 22.4088L4.44202 21.5655L6.23496 20.7222L5.28014 18.9859L7.22696 19.3583L7.47377 17.3916L8.82971 18.838L10.1858 17.3916L10.4325 19.3583L12.3793 18.9859L11.4246 20.7222L13.2175 21.5655Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Nauru;
